let bootstrapBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 970,
    xl: 1240,
    xxl: 1320
};

const styles = window.getComputedStyle(document.documentElement);
Object.keys(bootstrapBreakpoints).map(key => {
    const bootstrapBreakpoint = parseInt(styles.getPropertyValue(`--breakpoint-${key}`));
    if (!isNaN(bootstrapBreakpoint)) {
        bootstrapBreakpoints[key] = bootstrapBreakpoint;
    }
});

export default bootstrapBreakpoints;
